import { DialogContent, DialogTitle, styled } from "@mui/material";

export const ResponseScriptDialogTitle = styled(DialogTitle)(() => ({
  paddingBottom: 0,
  fontWeight: 400,
}));

export const ResponseScriptDialogContent = styled(DialogContent)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  padding: "16px",
  width: "600px",
}));
